import { S as Swiper } from './swiper-core-kdoF3145.js';
import { N as Navigation } from './navigation-BzJbeRPz.js';

class ShopTheLookSwiper extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.slidesPerViewDesktop = parseInt(this.dataset.slidesPerViewDesktop) || 1;
    this.slidesPerViewMobile = parseInt(this.dataset.slidesPerViewMobile) || 1;
    this.spaceBetweenSlides = parseInt(this.dataset.spaceBetweenSlides) || 0;

    new Swiper(this, {
      modules: [Navigation],
      spaceBetween: this.spaceBetweenSlides,
      slidesPerView: this.slidesPerViewMobile,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewDesktop,
        },
      },
    });
  }
}

customElements.define('shop-the-look-swiper', ShopTheLookSwiper);
